export const isLocalStorageAvailable = () => {
  try {
    localStorage.setItem("test", "test")
    localStorage.removeItem("test")
    return true
  } catch (error) {
    return false
  }
}

const customLocalStorage = isLocalStorageAvailable()
  ? localStorage
  : {
      getItem: () => null,
      setItem: () => null,
      removeItem: () => null,
      clear: () => null
    }

export default customLocalStorage
